class IndexMainSearch extends HTMLElement {

    

    constructor() {
        super();
        
        this.loadingClass = "loading";
        this.searchedClass = "searched";
        this.closingClass = "closing";
        this.searchOpenedClass = "body-search--open"
        this.firstTimeSearchClass = "first-time-search"
      

        this.selectors = {
            productItem: '.js-index-search-result-item',
            loading: `.${this.loadingClass}`,
            defaultLinks: '.js-default-links-container',
            defaultProducts: '.js-default-products-container'
        }

        this.form = this.querySelector('form');
        this.container = this.querySelector('.js-index-search-container');
        this.contentContainer = this.querySelector('.js-index-search-content-container');
        this.disclaimerContainer = this.querySelector('.js-index-search-content-disclaimer-container');
        this.searchInput = this.form.querySelector('.js-index-search-input')
        this.submitForm = this.form.querySelector('[type="submit"]');
        this.closeButtons = this.querySelectorAll('.js-index-search-close-icon')
        this.collectionResultsContainer = this.querySelector('.js-index-search-quick-links');
        this.collectionResultsWrapper = this.querySelector('.js-index-search-quick-links-container');
        this.productResultsContainer = this.querySelector('.js-index-search-results-container');
        this.resultsTitleContainer = this.querySelector('.js-index-search-results-header-container');
        this.resultsTitle = this.querySelector('.js-index-search-result-header');
        this.defaultLinks = this.querySelector(this.selectors.defaultLinks)?.innerHTML || "";
        this.defaultProducts = this.querySelector(this.selectors.defaultProducts)?.innerHTML || "";
        this.defaultTitle = this.resultsTitle.innerHTML;
        this.defaultPlaceholder = this.searchInput.placeholder;
        this.resetInputButton = this.querySelector('.js-index-search-form-clear-button');
        this.resultsCount = this.querySelector('.js-search-result-count');
        
        this.productResultsLimit = 20

        this.refinedSearch;
        this.currentSearch;
        this.currentSearchId;

        /** How close (px) to the bottom before we fetch the next batch */
        this.INFINITE_SCROLL_THRESHOLD = 150;
        this.PRODUCT_FETCH_URL = `${window.theme.apiUrl}/api/ai/search/test`;

        this.fetchCtrl = null;

        this.init();
    }

    connectedCallback() {
        /* Attach once when the element hits the DOM */
        if (!this._infiniteScrollBound) {
            this._infiniteScrollBound = this.handleInfiniteScroll.bind(this);
            this.productResultsContainer.addEventListener('scroll', this._infiniteScrollBound);
        }

        // Desktop wheel scroll redirection
        this.container.addEventListener('wheel', (e) => {
            // Only run if there is vertical scroll content
            if (!this.productResultsContainer.contains(e.target) && this.productResultsContainer.scrollHeight > this.productResultsContainer.clientHeight) {
                e.preventDefault();
                this.productResultsContainer.scrollTop += e.deltaY;
            }
        }, { passive: false });
    }

    init() {
        console.log('init search');
        this._resetPagination();
        this.cleanOldSearchCache();

        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.searchInput.addEventListener('keydown', this.handleInputChange.bind(this));
        this.searchInput.addEventListener('focus', this.handleInputFocus.bind(this));
        this.searchInput.addEventListener('blur', this.handleInputBlur.bind(this));

        this.closeButtons.forEach((button) => {
            button.addEventListener('click', this.handleClose.bind(this));
        })

        document.addEventListener('keydown', this.handleEscClose.bind(this));
        document.addEventListener('click', this.handleOutsideClick.bind(this), true);

        //add event handling for trending search
        this.querySelectorAll('.js-trending-search-item').forEach((item) => {
            item.addEventListener('click', this.handleTrendingSearchClick.bind(this));
        })

        this.resetInputButton.addEventListener('click', this.handleInputReset.bind(this));

        //window.addEventListener('resize', debounce(this.initSlider.bind(this), 500))

        // Check URL for initial search param
        const urlParams = new URLSearchParams(window.location.search);
        const initialQuery = urlParams.get('search');
        if (initialQuery) {
            this.restoreSearchFromHistory(initialQuery)
        }

        // Listen for back/forward navigation
        window.addEventListener('popstate', (event) => {
            if (event.state?.query) {
                this.restoreSearchFromHistory(event.state.query)
            } else {
                this.resetSearchUI();
            }
        });

        //add event tracking to the product
        this.productResultsContainer.addEventListener('click', this.handleQVClick.bind(this));

        //hide and show intercom
        this.handleIntercom();

        //init placeholder
        this.changePlaceholder();
    }

    handleTrendingSearchClick(event) {
        const element = event.target
        const search = element.dataset.search || "";

        if (!search) return

        this.searchInput.value = search
        
        this.form.requestSubmit();
    }

    handleEscClose(event) {
        if (event.key === "Escape" &&
            this.classList.contains(this.searchedClass)
        ) {
            this.handleClose()
        }
    }

    handleInputReset(event){
        event.preventDefault();
        event.stopPropagation();

        //clear signal
        // ① stop in-flight network activity
        if (this.fetchCtrl) this.fetchCtrl.abort();

        this.searchInput.value = '';
        this.resultsTitle.innerHTML = "";
        this.productResultsContainer.innerHTML = "";
        this.collectionResultsContainer.innerHTML = ""
        this.resultsCount.innerHTML = ""
        this.classList.add(this.firstTimeSearchClass);

    }

    handleOutsideClick(event) {

        const body = document.querySelector('body');

        if (
            !this.container.contains(event.target) &&
            this.classList.contains(this.searchedClass) &&
            !body.classList.contains('qv--open') &&
            !body.classList.contains('drawer-open')
        ) {
            //event.stopPropagation();
            this.handleClose();
        }
    }

    disableBodyScroll(){
        //body scroll lock
        bodyScrollLock.disableBodyScroll(this.productResultsContainer);
        bodyScrollLock.disableBodyScroll(this.collectionResultsContainer, { allowTouchMove: () => true });

        document.querySelector('body').classList.add(this.searchOpenedClass); 
        document.querySelector('html').classList.add(this.searchOpenedClass);
    }

    handleInputFocus() {
        this.classList.add('search-active');

        // Always scroll section to top on focus
        const rect = this.getBoundingClientRect();
        const offsetTop = window.scrollY + rect.top;

        // Jump instantly (no smooth) so it's ready before VKB shift
        window.scrollTo({
            top: offsetTop,
            behavior: 'instant' // or 'auto'
        });
        
        //open trending searches
        if (!this.classList.contains(this.searchedClass)) {
            this.classList.add(this.firstTimeSearchClass);
        }

        this.classList.add(this.searchedClass);

        this.disableBodyScroll();

        
    }

    handleInputBlur() {
        this.classList.remove('search-active');
    }

    handleQVClick(event){
      const qvTrigger = event.target.closest('.js-open-qv');
      if (qvTrigger) {
        this.handleProductView(qvTrigger);
        // your logic here
      }
    }

    handleProductView(element){
      const handle = element.dataset.handle;
      const aiSearchId = element.dataset.aiSearchId;
      const interactionType = "isViewed";
      
      const params = new URLSearchParams({
          handle: handle,
          searchId: aiSearchId,
          type: interactionType
      }).toString();
      
      fetch(`${window.theme.apiUrl}/api/ai/search/productInteraction`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({
            handle,
            searchId: aiSearchId,
            type: interactionType
          })
        })
        .then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                throw error;
            }
            return response.json();
        })
        .then((response) => {
            console.log(response);
        })
    }

    handleIntercom(){
    
      // Prevent creating multiple observers
      if (this._intercomObserver) return;
    
      const observerTarget = this;
    
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) {
            // Hide Intercom when the search container is visible
            window.Intercom?.('update', { hide_default_launcher: true });
            //console.log('intersect')
          } else {
            // Show it again when it's not
            window.Intercom?.('update', { hide_default_launcher: false });
            //console.log('not intersect')
          }
        },
        {
          root: null,
          threshold: 0.4 // Adjust as needed (20% visible = considered on screen)
        }
      );
    
      observer.observe(observerTarget);
    
      this._intercomObserver = observer;
    }

    handleClose(){
        // ① stop in-flight network activity
        if (this.fetchCtrl) this.fetchCtrl.abort();


        // Clear the URL parameter
        const url = new URL(window.location.href);
        url.searchParams.delete('search');
        history.pushState({}, '', url.toString());
        
        //remove products and collections
        this.productResultsContainer.innerHTML = "";
        this.collectionResultsContainer.innerHTML = "";
    
        // Clear input value
        this.searchInput.value = '';

        //reset min height
        this.container.style.minHeight = "auto";

        this.classList.add(this.closingClass);

        this.classList.remove(this.searchedClass);
        this.classList.remove(this.firstTimeSearchClass);
        
        //return to normal scrolling
        document.querySelector('body').classList.remove(this.searchOpenedClass); 
        document.querySelector('html').classList.remove(this.searchOpenedClass);

        // Remove 'searched' class
        setTimeout(function(){ 
            this.classList.remove(this.closingClass);
        }.bind(this), 1000)
        
        //disable body scroll lock
        bodyScrollLock.clearAllBodyScrollLocks();
      
    }

    changePlaceholder(){
        const windowWidth = window.innerWidth
        if(windowWidth < 768){
            this.searchInput.placeholder = window.theme.strings.mainSearch.placeholder_mobile;
        }else{
            this.searchInput.placeholder = window.theme.strings.mainSearch.placeholder;
        }
    }

    handleInputChange(event) {
        
        /*
        switch (event.code) {
            case 'Enter':
                event.preventDefault();
                this.handleSubmit(event);
                break;
        }*/

       // For textarea, intercept only plain Enter (not Shift+Enter)
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.handleSubmit(event);
        }      
    }

    handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        if (!this.form.checkValidity()) {
            this.form.reportValidity(); // shows native validation message
            return;
        }

        const query = this.searchInput.value;
        this.currentSearch = query;

        console.log('search', query);

        // Scroll results into view
        this.scrollResultsIntoView();

        
        //init search elements
        this.startSearch();
        this.search(query);

        // Push to history and update URL
        const url = new URL(window.location.href);
        url.searchParams.set('search', query);
        history.pushState({ query }, '', url.toString());

        // Pre-cache with empty data
        localStorage.setItem(`search:${query}`, JSON.stringify({
            timestamp: Date.now(),
            data: null
        }));
    }

    startSearch() {

        this._resetPagination();
        this._newFetchController();
        this.disableInputs();


        //add searched class
        this.classList.add(this.searchedClass);

        this.disableBodyScroll();

        //remove first time search
        this.classList.remove(this.firstTimeSearchClass);


        //clear product results
        this.productResultsContainer.innerHTML = '';

        this.resultsTitle.innerHTML = this.defaultTitle;

        //clear product results count
        this.updateResultsCount(0);

        //update fetching to true
        this.isFetchingMore = true;

    }

    disableInputs() {
        this.searchInput.disabled = true;
        this.submitForm.disabled = true;
    }

    enableInputs() {
        this.searchInput.disabled = false;
        this.submitForm.disabled = false;
    }

    search(query) {

        //add loading class
        this.classList.add(this.loadingClass);

        const limit = this.productResultsLimit;
        
        const locale = window.theme.apiLocale || 'us';
        const params = new URLSearchParams({
            search: query,
            limit,
            locale: locale.toLowerCase()
        }).toString();
        
        const ctrl = this.fetchCtrl;
        fetch(`${this.PRODUCT_FETCH_URL}?${params}`, {
            credentials: 'include',
            signal: ctrl.signal
        })
        .then((response) => {
            console.log('res', response);
            //alert(response)
            if (!response.ok) {
                var error = new Error(response.status);
                throw error;
            }
            console.log('res ok');
            return response.json();
        })
        .then((response) => {
            console.log(response);
            const { products, search } = response;

            // Cache in localStorage
            const cached = localStorage.getItem(`search:${query}`);
            if (cached) {
                const parsed = JSON.parse(cached);
                parsed.data = response;
                localStorage.setItem(`search:${query}`, JSON.stringify(parsed));
            }

            if (search == "no results" || !products || products.length == 0) {
                this.handleNoResults();
            } else {
                this.handleSearchReturn(response);
            }
        
        })
        .catch((error) => {
            console.log(error);

            if (error.name === 'AbortError') return;

            if (error?.code === 20) {
                // Code 20 means the call was aborted
                return;
            }

            this.handleNoResults();

            throw error;
        })
        .finally(() => {
            this.enableInputs();
            //remove loading class
            this.classList.remove(this.loadingClass);

            //always set fetching to false after;
            this.isFetchingMore = false;

            this.resizeContainer();
        });
        
        
    }

    restoreSearchFromHistory(query) {
        this.searchInput.value = this.currentSearch = query;
        this.startSearch();

        const cached = localStorage.getItem(`search:${query}`);
        if (cached) {
            const parsed = JSON.parse(cached);
            if (parsed.data) {
                setTimeout(() => {
                    this.handleSearchReturn(parsed.data);
                    this.enableInputs();
                    this.classList.remove(this.loadingClass);
                    //this.resizeContainer();
                    return;
                }, 3000);
                
                return;
            }
        }

        // If not cached or no data yet, fallback to live search
        this.search(query);
    }

    resetSearchUI() {
        /*
        this.classList.remove(this.searchedClass);
        this.classList.remove(this.firstTimeSearchClass)
        this.searchInput.value = '';
        this.resultsTitle.innerHTML = this.defaultTitle;
        this.productResultsContainer.innerHTML = this.defaultProducts;
        this.collectionResultsContainer.innerHTML = this.defaultLinks;
        this.collectionResultsWrapper.classList.remove('hidden');
        */
       this.handleClose();
    }

    //delete entries older than 1 day
    cleanOldSearchCache() {
        const now = Date.now();
        const oneDay = 24 * 60 * 60 * 1000;

        for (let key in localStorage) {
            if (key.startsWith('search:')) {
            try {
                const parsed = JSON.parse(localStorage.getItem(key));
                if (parsed.timestamp && now - parsed.timestamp > oneDay) {
                localStorage.removeItem(key);
                }
            } catch (e) {
                localStorage.removeItem(key);
            }
            }
        }
    }

    handleNoResults() {
        console.log('no results')
        const noResultTitle = window.theme.strings.mainSearch.no_results || "Your search did not yield any results."
        this.handleTitleChange(noResultTitle);
        this.productResultsContainer.innerHTML = this.defaultProducts;
        //this.collectionResultsContainer.innerHTML = this.defaultLinks;

        // Explicitly pass 0 results
        this.updateLiveRegion(0, 0);

        //clear product results count
        this.updateResultsCount(0);
        
    }

    handleSearchReturn(data) {
        const { collections, title, products, search, searchId, pagination } = data;

        //init actual search query used;
        this.refinedSearch = search;
        this.currentSearchId = searchId;

        this.handleCollectionResults(collections);
        this.handleTitleChange(title)
        this.handleProductResults(products);
        this._updatePaginationInfo(pagination, products.length);

        // Live region update with both counts
        const productCount = pagination?.total || 0;
        const collectionCount = Array.isArray(collections) ? collections.length : 0;
      
        this.updateLiveRegion(productCount, collectionCount);
        this.updateResultsCount(productCount);
        
        // Scroll results into view
        this.scrollResultsIntoView();

        this.resizeContainer();
    }


    updateResultsCount(productCount) {
        const resultsCount = this.resultsCount;
        if (productCount > 0) {
            resultsCount.innerHTML = `— ${productCount} ${window.theme.strings.mainSearch.results_count_suffix}`
        } else {
            resultsCount.innerHTML = '';
        }
        
    }

    handleTitleChange(title) { 
        const titleTemplate = `${title} — <span class="js-index-search-results-count index-search-results-count"></span>`
        this.resultsTitle.innerHTML = title;
    }

    handleCollectionResults(collections) {
        let results = ''

        if (collections && collections.length == 0) {
            this.collectionResultsWrapper.classList.add('hidden');
            return;
        } else {
            this.collectionResultsWrapper.classList.remove('hidden');
        }
        

        collections?.forEach((collection) => {
            const url = `/collections/${collection.handle}`
            const template = `<li class="index-search-quick-link glass-effect">
                <a target="_blank" href="${url}">${collection.title}</a>
            </li>`

            results += template;
        })

        this.collectionResultsContainer.innerHTML = results
    }

    handleProductResults(products, append = false) {
        if (!append) this.clearProductResults();  

        const button_text = window.theme.strings.mainSearch.button_text || "Shop Now"

        products.forEach((product, i) => {

            const imgUrl   = `${product.featuredImage?.url}&width=800`;
            const money    = slate.Currency.formatMoney(
                                product.priceRangeV2?.minVariantPrice.amount,
                                theme.moneyFormat
                            );

            const template = `
            <a href="${product.onlineStoreUrl}"
                class="js-open-qv"
                data-handle="${product.handle}"
                data-ai-query="${this.refinedSearch}"
                data-ai-search-id="${this.currentSearchId}">
                    <div class="index-search-result-item-image-container responsive-media-container">
                        <img height="800" width="800" src="${imgUrl}" alt="${product.title} product image">
                    </div>
                    <div class="index-search-result-item-content-container">
                        <h3 class="index-search-result-item-title">${product.title}</h3>
                        <div class="index-search-result-item-price-container">
                            <span class="price"><span class="money">${money}</span></span>
                        </div>
                        <span class="index-search-result-item-button btn__underline-animation reverse">${button_text}</span>
                        ${ i == 0 ? `<span class="index-search-result-item-footer-text">${window.theme.strings.mainSearch.why_selected_text}</span>` : ""}
                    </div>
            </a>`;

            /* Fill an existing “loading” block first, else append a new one */
            let block = this.productResultsContainer.querySelector(
                        `${this.selectors.productItem}.${this.loadingClass}`
                        );
            if (!block) {
            block = document.createElement('div');
            block.classList.add('index-search-result-item',
                                'js-index-search-result-item',
                                'glass-effect');
            this.productResultsContainer.appendChild(block);
            }
            block.innerHTML = template;
            block.classList.remove(this.loadingClass);
        });
        
    }


    //look for blocks with loading and remove them after results has been processed
    cleanProductContainer() {

        this.querySelectorAll(this.selectors.productItem + this.selectors.loading).forEach((item) => {
            item.remove();
        })
    }

    clearProductResults() {
        
        const $slider = $(this.productResultsContainer);

        console.log('clea slider', $slider);

        if ($slider.hasClass('slick-initialized')) {
            $slider.slick("unslick");
            console.log('clea after', $slider);
        }
        
        this.querySelectorAll(this.selectors.productItem).forEach((item) => {
            item.innerHTML = '';
            item.classList.add(this.loadingClass);
        })
        
    }

    resizeContainer() {
        const contentContainerHeight = this.contentContainer.offsetHeight;
        const disclaimerContainerHeight = this.disclaimerContainer.offsetHeight;
        const spacing = 70;


        /*
        const containerHeight = contentContainerHeight + disclaimerContainerHeight + spacing;

        this.container.style.minHeight = `${containerHeight}px`;
        */


        //on mobile resize results container to fit mobile screen
        const windowWidth = window.innerWidth;
        if (windowWidth < 768) {
            const elementHeight = this.offsetHeight;
            const formHeight = this.form.offsetHeight;
            const titleContainerHeight = this.resultsTitleContainer.offsetHeight;
            const collectionContainerHeight = this.collectionResultsWrapper.offsetHeight;

            console.log(`elHeight`, elementHeight);
            console.log(`formHeight`, formHeight);
            console.log(`titleCOntianer`, titleContainerHeight);
            console.log(`collectionContainer`, collectionContainerHeight)
            console.log(`disclaimer`, disclaimerContainerHeight)
            console.log('minus', (formHeight + titleContainerHeight + disclaimerContainerHeight + collectionContainerHeight + (spacing * 2)));

            const resultContainerHeight = elementHeight - (formHeight + titleContainerHeight + disclaimerContainerHeight + collectionContainerHeight + (spacing * 2));

            this.productResultsContainer.style.minHeight = `${resultContainerHeight}px`
            this.productResultsContainer.style.maxHeight = `${resultContainerHeight}px`
        }
    }


    updateLiveRegion(productsCount = 0, collectionsCount = 0) {
      const liveRegion = this.querySelector('[data-ai-search-live-region-count-value]');
      if (liveRegion) {
        let messageParts = [];
    
        if (collectionsCount > 0) {
          messageParts.push(`${collectionsCount} collection${collectionsCount !== 1 ? 's' : ''}`);
        }
    
        if (productsCount > 0) {
          messageParts.push(`${productsCount} product${productsCount !== 1 ? 's' : ''}`);
        }
    
        const message = messageParts.length
          ? `${messageParts.join(' and ')} found`
          : `No results found`;
    
        liveRegion.textContent = message;
      }
    }


    scrollResultsIntoView() {
      const container = this.container;
      if (!container) return;
    
      const rect = container.getBoundingClientRect();
    
      // Already in view (with offset)?
      const offset = 60;
      const aboveTop = rect.top - offset;
      const belowBottom = rect.bottom - (window.innerHeight || document.documentElement.clientHeight);
    
      if (aboveTop >= 0 && belowBottom <= 0) {
        // Already in view (with offset)
        return;
      }
    
      // Get the absolute scroll position for the top of the container minus offset
      const scrollTo = window.scrollY + rect.top - offset;
    
      window.scrollTo({
        top: scrollTo,
        behavior: "smooth"
      });
    }


    /* ───────────────  State helpers ─────────────── */
    _resetPagination() {
        this.productsLoaded   = 0;       // how many we have rendered so far
        this.totalProducts    = 0;       // will be set on first response
        this.isFetchingMore   = false;
        this.hasMoreResults   = true;
    }

    /* Call this at the *end* of handleSearchReturn() */
    _updatePaginationInfo(pagination, productsLength) {
        this.productsLoaded += productsLength;
        this.totalProducts  = pagination?.total ?? this.productsLoaded;
        this.hasMoreResults = this.productsLoaded < this.totalProducts;
        
        console.log(`update pagination: loaded: ${this.productsLoaded}. Total: ${this.totalProducts}. Has more: ${this.hasMoreResults}`)
    }


    /* ------------------------------------------------------------------ */
    /*  Scroll watcher – fires when user nears bottom of the container    */
    /* ------------------------------------------------------------------ */
    handleInfiniteScroll() {
        if (!this.hasMoreResults || this.isFetchingMore) return;

        const el = this.productResultsContainer;
        const nearBottom =
                el.scrollTop + el.clientHeight >= el.scrollHeight - this.INFINITE_SCROLL_THRESHOLD;

        if (!nearBottom) return;

        this.isFetchingMore = true;
        //calculate number of skeletons
        const skeletonNumber = Math.min(this.totalProducts - this.productsLoaded, this.productResultsLimit);
        this._appendLoadingSkeletons(skeletonNumber);   // visual feedback
        this._fetchNextPage()
            .finally(() => { this.isFetchingMore = false; });
    }

    
    /* ------------------------------------------------------------------ */
    /*  Fetch the next “page” of products                                 */
    /* ------------------------------------------------------------------ */
    _fetchNextPage() {
        const limit = this.productResultsLimit;
        const offset = this.productsLoaded;  
        const page = Math.floor(offset / limit);

        const locale = (window.theme.apiLocale || 'us').toLowerCase();
        const params = new URLSearchParams({
            search : this.currentSearch,
            limit,
            page,         
            locale
        }).toString();

        const ctrl = this.fetchCtrl;
        return fetch(`${this.PRODUCT_FETCH_URL}?${params}`, {
                    credentials: 'include',
                    signal: ctrl.signal
                })
                .then(r => {
                    if (!r.ok) throw new Error(r.status);
                    return r.json();
                })
                .then(({ products = [], pagination = {} }) => {
                    /* Re-use your renderer but *append* this time */
                    this.handleProductResults(products, true);
                    this._updatePaginationInfo(pagination, products.length);
                }).finally(() => {
                    //remove all unused skeletons
                    this.cleanProductContainer();
                })
                .catch(err => {
                    if (err.name === 'AbortError') return;
                });
    }

    /* ------------------------------------------------------------------ */
    /*  Utilities                                                         */
    /* ------------------------------------------------------------------ */

    /** Creates the grey “loading” cards you already rely on */
    _appendLoadingSkeletons(count) {
        for (let i = 0; i < count; i++) {
            const skel = document.createElement('div');

            const skelTemplate = `
            <!-- image placeholder -->
            <div class="skeleton skeleton--image"></div>

            <!-- content -->
            <div class="index-search-result-item-content-container">
                <div class="skeleton skeleton--title"></div>
                <div class="skeleton skeleton--price"></div>
                <div class="skeleton skeleton--button"></div>
            </div>
            `

            skel.innerHTML = skelTemplate

            skel.classList.add(
                'index-search-result-item',
                'js-index-search-result-item',
                'glass-effect',
                this.loadingClass
            );
            this.productResultsContainer.appendChild(skel);
        }
    }

    /** Abort any old requests and return a fresh controller */
    _newFetchController() {
        if (this.fetchCtrl) this.fetchCtrl.abort();   // cancel leftovers
        this.fetchCtrl = new AbortController();
        return this.fetchCtrl;
    }
}
  
customElements.define('index-main-search', IndexMainSearch);